import { render, staticRenderFns } from "./customer-phone.vue?vue&type=template&id=8413cc18&scoped=true"
import script from "./customer-phone.vue?vue&type=script&lang=js"
export * from "./customer-phone.vue?vue&type=script&lang=js"
import style0 from "./customer-phone.vue?vue&type=style&index=0&id=8413cc18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8413cc18",
  null
  
)

export default component.exports